<div class="crousel mb-4">
  <img
    *ngIf="slides[currentIndex].type === 'image'"
    [src]="slides[currentIndex].image"
    alt=""
  />
  <video #video *ngIf="slides[currentIndex].type === 'video'" controls>
    <source type="video/mp4" [src]="slides[currentIndex].image" />
  </video>
  <div class="controls">
    <button [disabled]="currentIndex === 0" mat-icon-button class="prev">
      <mat-icon
        aria-hidden="false"
        aria-label="Example home icon"
        (click)="prev()"
        >navigate_before</mat-icon
      >
    </button>
    <button
      [disabled]="currentIndex === slides.length - 1"
      mat-icon-button
      class="next"
    >
      <mat-icon
        aria-hidden="false"
        aria-label="Example home icon"
        (click)="next()"
        >navigate_next</mat-icon
      >
    </button>
  </div>
  <!-- <button class="btn btn-secondary prev" (click)="prev()">Prev</button> -->
</div>
